import dayjs, { Dayjs } from 'dayjs';
import i18n from '../translations/i18n';
import {
  format,
  formatDuration,
  getDefaultOptions,
  intervalToDuration,
} from 'date-fns';

const localeDateTimeFormat: Record<string, string> = {
  en: 'MMMM d, yyyy',
  nl: 'd MMMM yyyy',
  es: 'd MMMM yyyy',
};

const localeDateTimeFormatsEvent: Record<string, string> = {
  en: 'EEEE d MMMM',
  nl: 'EEEE d MMMM',
  es: "EEEE d 'de' MMMM",
};

const localeDateTimeFormatsEventTime: Record<string, string> = {
  en: "'at' H:mm",
  nl: "'om' H:mm",
  es: "'a las' H:mm",
};

export const formatLocaleDate = (
  date: Date | string,
  withTime: boolean = true
) => {
  let formatStr = localeDateTimeFormat[i18n.language];

  if (withTime) {
    formatStr += ' HH:mm';
  }

  return format(date, formatStr);
};

export const formatToLocaleEventDate = (
  date: Date | string,
  withTime: boolean = true
) => {
  let formatStr = localeDateTimeFormatsEvent[i18n.language];

  if (withTime) {
    formatStr += ' ' + localeDateTimeFormatsEventTime[i18n.language];
  }

  return format(date, formatStr);
};

const combineTimeSegments = (timeString: string): string => {
  const parts = timeString.split(' ');
  const segments: string[] = [];

  for (let i = 0; i < parts.length; i += 2) {
    segments.push(`${parts[i]} ${parts[i + 1]}`);
  }

  if (segments.length === 0) return '';
  if (segments.length === 1) return segments[0];
  if (segments.length === 2) return `${segments[0]} and ${segments[1]}`;

  const last = segments.pop();

  return `${segments.join(', ')} ${i18n.t('words.and')} ${last}`;
};

export const getReadableTimeDifferenceInLocale = (
  start: Date,
  end: Date
): string => {
  const locale = getDefaultOptions().locale;
  const duration = intervalToDuration({ start, end });

  return combineTimeSegments(
    formatDuration(duration, {
      format: ['days', 'hours', 'minutes'],
      locale,
    })
  );
};

export function isValidDate(date: Dayjs | null | undefined): boolean {
  return dayjs.isDayjs(date) && date.isValid();
}

export function isTodayOrPast(date: Dayjs): boolean {
  return date.isBefore(dayjs()) || date.isSame(dayjs());
}

export function isTodayOrFuture(
  date: Dayjs,
  ignoreTime: boolean = false
): boolean {
  const today = ignoreTime ? dayjs().startOf('day') : dayjs();
  const targetDate = ignoreTime ? date.startOf('day') : date;

  return targetDate.isSame(today) || targetDate.isAfter(today);
}
